import { RouteType } from "../../../types/RouteType";

const cylinderBreakEntryRoute: RouteType = {
  name: "Cylinder Break Entry",
  path: "/qc/cylinder-break",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./CylinderBreakEntry.Header"),
      title: "Cylinder Break Entry",
      color: "primary",
    },
    body: {
      component: () => import("./CylinderBreakEntry.Body"),
      grayBackground: true,
    },
  },
  group: "Quality Control",
  requiresAuth: true,
  requiresPermission: false,

  beforeEnter: async () => {
    return true;
  },

  dialogs: [],
};

export default cylinderBreakEntryRoute;
